import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox", "input"];
    declare readonly checkboxTargets: HTMLInputElement[];
    declare readonly inputTargets: HTMLInputElement[];

    connect() {
        this.attachListeners(this.checkboxTargets);
        this.attachListeners(this.inputTargets);
        document.addEventListener("map-modal-filter-changed", this.syncState as EventListener);
    }

    disconnect() {
        this.detachListeners(this.checkboxTargets);
        this.detachListeners(this.inputTargets);
    }

    attachListeners(targets: HTMLInputElement[]) {
        targets.forEach((target) => {
            target.addEventListener("change", this.fireFilterChangedEvent);
        });
    }

    detachListeners(targets: HTMLInputElement[]) {
        targets.forEach((target) => {
            target.removeEventListener("change", this.fireFilterChangedEvent);
        });
    }

    fireFilterChangedEvent = (): void => {
        const filterValues: {
            checkboxes: { [name: string]: string[]; },
            inputs: { [name: string]: string; }
        } = {
            checkboxes: {},
            inputs: {}
        };

        this.checkboxTargets.filter(checkbox => checkbox.checked).map(checkbox => {
            if (!filterValues.checkboxes[checkbox.name]) {
                filterValues.checkboxes[checkbox.name] = [];
            }

            (filterValues.checkboxes[checkbox.name]).push(checkbox.value);
        });

        this.inputTargets.filter(input => input.value).map(input => {
            filterValues.inputs[input.name] = input.value;
        });

        this.element.dispatchEvent(
          new CustomEvent("map-sidebar-filter-changed", { detail: filterValues, bubbles: true })
        );
    }

    syncState = (event: CustomEvent<{
        checkboxes: { [name: string]: string[]; },
        inputs: { [name: string]: string; }
    }>): void => {
        console.log('Sidebar: sync modal state');

        this.checkboxTargets.forEach(checkbox => {
            checkbox.checked = !!event.detail.checkboxes[checkbox.name]?.includes(checkbox.value);
        });

        this.inputTargets.forEach(input => {
            input.value = event.detail.inputs[input.name] || "";
        });
    }
}